"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingReadOnly = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const SettingReadOnly = (props) => {
    const { label, value } = props;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "center" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { display: "block", variant: "caption", color: "textSecondary" }, label),
                react_1.default.createElement(core_1.Typography, { display: "block" }, value)))));
};
exports.SettingReadOnly = SettingReadOnly;
//# sourceMappingURL=index.js.map